import {Box} from '@mantine/core';
import React from 'react';

export interface ProteinEntityStructureTabViewProps {
  proteinId: string;
}

export default function ProteinEntityStructureTabView({
  proteinId,
}: ProteinEntityStructureTabViewProps): JSX.Element {
  return <Box data-protein-id={proteinId} />;
}
